var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivityLogs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.78897 14.0883C3.11591 14.2056 3.4725 14.0338 3.58831 13.711L5.23597 9.11757C5.39584 8.67181 5.97322 8.55907 6.28925 8.91094L6.51375 9.16088C7.43428 10.1858 9.11091 9.90169 9.64025 8.62725L11.0642 5.19919C11.2406 4.77435 11.8013 4.6786 12.1082 5.02347L12.5331 5.50088C12.7626 5.75872 13.1576 5.78175 13.4155 5.55228C13.6733 5.32281 13.6964 4.92775 13.4669 4.66991L13.042 4.1925C12.1237 3.16063 10.4406 3.44172 9.90978 4.71972L8.48587 8.14778C8.30925 8.57303 7.75169 8.66853 7.44372 8.32563L7.21922 8.07569C6.27147 7.02041 4.539 7.35838 4.05937 8.69553L2.41172 13.289C2.29516 13.6139 2.46406 13.9717 2.78897 14.0883Z",
    fill: "#15243E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.375 15.25H1.875C1.53038 15.25 1.25 14.9696 1.25 14.625V1.125C1.25 0.779813 0.970187 0.5 0.625 0.5C0.279813 0.5 0 0.779813 0 1.125V14.625C0 15.6589 0.841125 16.5 1.875 16.5H15.375C15.7202 16.5 16 16.2202 16 15.875C16 15.5298 15.7202 15.25 15.375 15.25Z",
    fill: "#15243E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityLogs);
export default __webpack_public_path__ + "static/media/activity-logs.4b91cc06771e3db2d4c0f1fb24e17ba3.svg";
export { ForwardRef as ReactComponent };